var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBgvAboutUsCardOne(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 115,
    height: 141,
    viewBox: "0 0 115 141",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.529 105.294C92.8633 105.294 105.294 92.8633 105.294 77.529C105.294 62.1946 92.8633 49.7637 77.529 49.7637C62.1946 49.7637 49.7637 62.1946 49.7637 77.529C49.7637 92.8633 62.1946 105.294 77.529 105.294ZM77.5275 87.4456C83.004 87.4456 87.4437 83.006 87.4437 77.5295C87.4437 72.0529 83.004 67.6133 77.5275 67.6133C72.0509 67.6133 67.6113 72.0529 67.6113 77.5295C67.6113 83.006 72.0509 87.4456 77.5275 87.4456Z",
    fill: "url(#paint0_linear_79_862)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.755 33.9607C33.153 33.5517 33.5566 33.1481 33.9656 32.7501L40.5817 39.3662L40.1967 27.4322C50.6117 19.6581 63.5326 15.0557 77.5285 15.0557C112.031 15.0557 140 43.0253 140 77.5275C140 112.03 112.031 139.999 77.5285 139.999C43.0263 139.999 15.0566 112.03 15.0566 77.5275C15.0566 63.5299 19.6603 50.6075 27.4361 40.1918L39.3711 40.5768L32.755 33.9607ZM77.5289 122.646C102.447 122.646 122.647 102.446 122.647 77.5279C122.647 52.6096 102.447 32.4093 77.5289 32.4093C52.6106 32.4093 32.4103 52.6096 32.4103 77.5279C32.4103 102.446 52.6106 122.646 77.5289 122.646Z",
    fill: "url(#paint1_linear_79_862)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M77.5287 122.646C102.447 122.646 122.647 102.446 122.647 77.5278C122.647 52.6095 102.447 32.4092 77.5287 32.4092C52.6104 32.4092 32.4102 52.6095 32.4102 77.5278C32.4102 102.446 52.6104 122.646 77.5287 122.646ZM77.5291 105.293C92.8634 105.293 105.294 92.8624 105.294 77.5281C105.294 62.1938 92.8634 49.7628 77.5291 49.7628C62.1947 49.7628 49.7638 62.1938 49.7638 77.5281C49.7638 92.8624 62.1947 105.293 77.5291 105.293Z",
    fill: "url(#paint2_linear_79_862)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.147 77.5278C122.147 102.17 102.171 122.146 77.5287 122.146V123.146C102.723 123.146 123.147 102.722 123.147 77.5278H122.147ZM77.5287 32.9092C102.171 32.9092 122.147 52.8856 122.147 77.5278H123.147C123.147 52.3333 102.723 31.9092 77.5287 31.9092V32.9092ZM32.9102 77.5278C32.9102 52.8856 52.8866 32.9092 77.5287 32.9092V31.9092C52.3343 31.9092 31.9102 52.3333 31.9102 77.5278H32.9102ZM77.5287 122.146C52.8866 122.146 32.9102 102.17 32.9102 77.5278H31.9102C31.9102 102.722 52.3343 123.146 77.5287 123.146V122.146ZM104.794 77.5281C104.794 92.5863 92.5873 104.793 77.5291 104.793V105.793C93.1396 105.793 105.794 93.1386 105.794 77.5281H104.794ZM77.5291 50.2628C92.5873 50.2628 104.794 62.4699 104.794 77.5281H105.794C105.794 61.9176 93.1396 49.2628 77.5291 49.2628V50.2628ZM50.2638 77.5281C50.2638 62.4699 62.4709 50.2628 77.5291 50.2628V49.2628C61.9186 49.2628 49.2638 61.9176 49.2638 77.5281H50.2638ZM77.5291 104.793C62.4709 104.793 50.2638 92.5863 50.2638 77.5281H49.2638C49.2638 93.1386 61.9186 105.793 77.5291 105.793V104.793Z",
    fill: "#302F3A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 77.5272,
    cy: 77.5282,
    r: 9.17665,
    fill: "url(#paint3_linear_79_862)",
    fillOpacity: 0.5,
    stroke: "#AAECD8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.9293 40.8803C19.4607 51.1745 15.0566 63.8367 15.0566 77.5275C15.0566 112.03 43.0263 139.999 77.5285 139.999C112.031 139.999 140 112.03 140 77.5275C140 43.0253 112.031 15.0557 77.5285 15.0557C63.8873 15.0557 51.2673 19.4278 40.9933 26.8473",
    stroke: "#302F3A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6778 13.9707C14.4825 13.7754 14.1659 13.7754 13.9707 13.9707C13.7754 14.1659 13.7754 14.4825 13.9707 14.6778L14.6778 13.9707ZM13.9707 14.6778L70.1469 70.854L70.854 70.1469L14.6778 13.9707L13.9707 14.6778Z",
    fill: "#AAECD8"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-8-outside-1_79_862",
    maskUnits: "userSpaceOnUse",
    x: 9.7723,
    y: -0.414214,
    width: 42.4264,
    height: 42.4264,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: 9.7723,
    y: -0.414214,
    width: 42.4264,
    height: 42.4264
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3789 1L39.9722 20.5932L40.5778 39.3672L20.9845 19.7739L20.3789 1Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.3789 1L39.9722 20.5932L40.5778 39.3672L20.9845 19.7739L20.3789 1Z",
    fill: "url(#paint4_linear_79_862)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3789 1L21.086 0.292893C20.7959 0.00274011 20.3579 -0.080711 19.9814 0.0824105C19.6049 0.245532 19.3662 0.622116 19.3794 1.03224L20.3789 1ZM39.9722 20.5932L40.9716 20.561C40.9634 20.3071 40.8589 20.0658 40.6793 19.8861L39.9722 20.5932ZM40.5778 39.3672L39.8707 40.0743L41.6588 41.8624L41.5772 39.3349L40.5778 39.3672ZM20.9845 19.7739L19.985 19.8062C19.9932 20.0601 20.0978 20.3014 20.2774 20.481L20.9845 19.7739ZM19.6718 1.70711L39.265 21.3004L40.6793 19.8861L21.086 0.292893L19.6718 1.70711ZM38.9727 20.6255L39.5783 39.3994L41.5772 39.3349L40.9716 20.561L38.9727 20.6255ZM41.2849 38.6601L21.6916 19.0668L20.2774 20.481L39.8707 40.0743L41.2849 38.6601ZM21.984 19.7417L21.3784 0.967759L19.3794 1.03224L19.985 19.8062L21.984 19.7417Z",
    fill: "#AAECD8",
    mask: "url(#path-8-outside-1_79_862)"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "path-10-outside-2_79_862",
    maskUnits: "userSpaceOnUse",
    x: -0.414214,
    y: 9.7723,
    width: 42.4264,
    height: 42.4264,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    x: -0.414214,
    y: 9.7723,
    width: 42.4264,
    height: 42.4264
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 20.3789L20.5932 39.9722L39.3672 40.5778L19.7739 20.9845L1 20.3789Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M1 20.3789L20.5932 39.9722L39.3672 40.5778L19.7739 20.9845L1 20.3789Z",
    fill: "url(#paint5_linear_79_862)",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1 20.3789L0.292893 21.086C0.00274011 20.7959 -0.080711 20.3579 0.0824105 19.9814C0.245532 19.6049 0.622116 19.3662 1.03224 19.3794L1 20.3789ZM20.5932 39.9722L20.561 40.9716C20.3071 40.9634 20.0658 40.8589 19.8861 40.6793L20.5932 39.9722ZM39.3672 40.5778L40.0743 39.8707L41.8624 41.6588L39.3349 41.5772L39.3672 40.5778ZM19.7739 20.9845L19.8062 19.985C20.0601 19.9932 20.3014 20.0978 20.481 20.2774L19.7739 20.9845ZM1.70711 19.6718L21.3004 39.265L19.8861 40.6793L0.292893 21.086L1.70711 19.6718ZM20.6255 38.9727L39.3994 39.5783L39.3349 41.5772L20.561 40.9716L20.6255 38.9727ZM38.6601 41.2849L19.0668 21.6916L20.481 20.2774L40.0743 39.8707L38.6601 41.2849ZM19.7417 21.984L0.967759 21.3784L1.03224 19.3794L19.8062 19.985L19.7417 21.984Z",
    fill: "#AAECD8",
    mask: "url(#path-10-outside-2_79_862)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_79_862",
    x1: 49.7637,
    y1: 49.7637,
    x2: 115.07,
    y2: 89.0399,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_79_862",
    x1: 15.0566,
    y1: 15.0557,
    x2: 161.996,
    y2: 103.427,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_79_862",
    x1: 32.4102,
    y1: 32.4092,
    x2: 138.533,
    y2: 96.233,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#30303A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#30303A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_79_862",
    x1: 77.5272,
    y1: 69.7192,
    x2: 77.5272,
    y2: 86.2049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_79_862",
    x1: 39.2739,
    y1: 20.864,
    x2: 30.0687,
    y2: 30.0693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_79_862",
    x1: 20.864,
    y1: 39.2739,
    x2: 30.0693,
    y2: 30.0687,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#AAECD8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#AAECD8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgvAboutUsCardOne);
export default __webpack_public_path__ + "static/media/BGVAboutUsCardOne.b0523327ea3789c98429435535c4fdbc.svg";
export { ForwardRef as ReactComponent };